import React, { useState } from 'react'
import { Form } from 'react-router-dom'
import { barely, reciept_header, Footer_img, barely_black_bg_img } from '../../../public/LoginImages/importimages'
import { apiurl } from '../../../path'
import { usePDF } from 'react-to-pdf';
import './innercss.css'
const RegistrationForm = () => {
    const [form, setform] = useState({
        PAN_No: "",
        GST_No: ""
    })
    const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
    const [Table, SetTable] = useState([])
    const [searchdata, setSearchdata] = useState([])
    const [hide, Sethide] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = Table.slice(indexOfFirstItem, indexOfLastItem);
    const [loading, setloading] = useState(false)

    const handlechange = (e) => {
        setform({ ...form, [e.target.id]: e.target.value })
    }

    const [paymentdata, Setpaymentdata] = useState({})

    async function Submit() {

        Sethide(true)
        setloading(true)
        try {
            let data = await fetch(
                `${apiurl}/BidderRegister/GetRegistrationDetails`,
                {
                    method: 'post',
                    headers: ({ 'Content-Type': 'Application/json' }),
                    body: JSON.stringify({ ...form })
                })
            data = await data.json()
            console.log(data)
            setSearchdata(data)
            if (data === false) {
                Sethide(false)
                setloading(false)
                return alert('incorrect gst or pan')
            }
            else {
                SetTable(data)
                setloading(false)
            }
        } catch (error) {
            console.error('Error in Submit:', error);
        }

    }


    const search = (e) => {
        try {
            let searchValue = e.target.value.toLowerCase();

            if (!searchValue) {
                SetTable(searchdata); // If search value is empty, show all data
                return;
            }

            let newdata = searchdata.filter((item) => {
                // Check for a match in multiple fields
                return (
                    item.TenderFee.toString().includes(searchValue) ||
                    item.Bidder_CompanyName.toString().includes(searchValue) 
                    // item.TenderFee.toString().includes(searchValue) ||
                    // item.net_amount_debit.toString().includes(searchValue)
                );
            });

            SetTable(newdata);
            console.log(newdata);
        } catch (error) {
            console.error('Error in search:', error);
        }
    }

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <>
            <div id='tablesdata' style={{ justifyContent: 'center', display: 'grid', alignItems: 'center', height: '100vh', backgroundImage: `url(${barely_black_bg_img})`, backgroundSize: "cover" }}>

                <div className="card-body">
                    <Form hidden={hide} className='searchTender' onSubmit={Submit} style={{ background: "linear-gradient(rgba(255,255,255,0.8),rgba(255,255,255,0.8))", borderRadius: '1rem', padding: '2rem', height: "70%" }}>
                        <h3 style={{ textAlign: "center" }}>Registration Details</h3>
                        <hr></hr>
                        <div className="mb-3">
                            <label htmlFor="exampleInputEmail1" className="form-label"><b>GST Number</b></label>
                            <input type="text" className="form-control" id="GST_No" value={form.GST_No} onChange={(e) => handlechange(e)} aria-describedby="emailHelp" required />
                            <div id="emailHelp" className="form-text">We'll never share your GST no. with anyone else.</div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="exampleInputPassword1" className="form-label"><b>Pan number</b></label>
                            <input type="text" className="form-control" value={form.PAN_No} id="PAN_No" required onChange={(e) => handlechange(e)} />
                        </div>
                        <div className="mb-3 form-check">
                            <input type="checkbox" className="form-check-input" id="exampleCheck1" required />
                            <label className="form-check-label" htmlFor="exampleCheck1">Check me out</label>
                        </div>
                        <div style={{ display: "grid", justifyContent: "center" }}>
                            <button type="submit" className="btn btn-success">Submit</button>
                        </div>
                    </Form>
                </div>



                {
                    loading ? (
                        <div className='loader'></div>
                    ) : (
                        <div hidden={!hide} style={{ overflow: "auto", background: "transparent", border: "none" }} className="card" >
                            {/* <span style={{ display: "flex", justifyContent: "center" }}>
                                <input className='form-control' type='search' placeholder='Search Details by Tender Name or Tender_Fee' onChange={(e) => { search(e) }} />
                            </span> */}

                            <table className="card-body table table-dark" style={{ marginTop: '20px', border: '1px solid black' }}>
                                <thead>
                                    <tr style={{ backgroundColor: 'lightblue' }}>
                                        <th>Regiteration Id</th>
                                        <th>Tender Name</th>
                                        <th>Bidder CompanyName</th>
                                        <th>GST No</th>
                                        <th>Account No</th>
                                        <th>IFSC Code</th>
                                        <th>Bank Name</th>
                                        <th>Account HolderName</th>
                                        <th>Branch Name</th>
                                        <th>Payment Amount</th>
                                        <th>Tender Fee</th>
                                        <th>EMD</th>
                                        <th>Gst Amount</th>
                                        <th>Tender Status</th>
                                        <th>Winning Status</th>
                                        <th>Refund Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.map((e, index) => (
                                        <tr key={index} style={{ backgroundColor: index % 2 === 0 ? 'lightgray' : 'white' }}>
                                            <th>{e.Regiterationid}</th>
                                            <th>{e.Tender_Name}</th>
                                            <th>{e.Bidder_CompanyName}</th>
                                            <th>{e.GST_No}</th>
                                            <th>{e.Account_Number}</th>
                                            <th>{e.IFSC_CODE}</th>
                                            <th>{e.BANK_NAME}</th>
                                            <th>{e.Account_HolderName}</th>
                                            <th>{e.BranchName}</th>
                                            <th>{e.PaymentAmount}</th>
                                            <th>{e.TenderFee}</th>
                                            <th>{e.ErnestMoneyDeposit}</th>
                                            <th>{e.GstAmount}</th>
                                            <th>{e.TenderStatus}</th>
                                            <th>{e.WinningStatus}</th>
                                            <th>{e.Refund_Status}</th>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )
                }

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <ul className="pagination">
                        {Array(Math.ceil(Table.length / itemsPerPage))
                            .fill()
                            .map((_, index) => (
                                <li key={index} className="page-item">
                                    <button onClick={() => paginate(index + 1)} className="page-link">
                                        {index + 1}
                                    </button>
                                </li>
                            ))}
                    </ul>
                </div>


            </div>

        </>
    )
}

export default RegistrationForm